import { memo } from 'react';

const React = require('react');
const _ = require('lodash');

const ChannelFormatter = (props) => {
  return <div>{_.map(props.dependentValues.rowData.channels, 'description').join(', ')}</div>;
};

export default memo(ChannelFormatter, (prevProps, nextProps) => nextProps.value === prevProps.value);
